module.exports = __webpack_public_path__ + "img/_empty_states_case_notes.6a1f25e7.svg";